import React, { Component } from 'react';
import config from '../../config';
import { Link } from 'react-router';

class NavbarLogo extends Component {
	render() {
		return (
			<Link to="/" className="Navbar-logo Text--xlarge" title={config.siteName}>
				<span className="Navbar-textOverlay" data-hover={config.siteName}>
					<span className="Text--plain">Magic</span>
					<span className="Text--branded"> Card Buyer</span>
				</span>
			</Link>
		)
	}
}

export default NavbarLogo;



/** WEBPACK FOOTER **
 ** ./src/components/NavbarLogo/NavbarLogo.js
 **/